import React from "react";
import { Dropdown } from "react-bootstrap";
import UNITS from "../../../assets/mass-units.json";
import CURRENCY_UNITS from "../../../assets/currency-units.json";

const ItemDetailsFormFields = ({
  item,
  onUpdate,
  errors,
  hideValueCurrency = false,
}) => {
  const CURRENCY = CURRENCY_UNITS;

  const renderWeight = () => {
    const list = Object.keys(UNITS).map((unit, idx) => (
      <Dropdown.Item key={idx} onClick={() => onUpdate("weight_unit", unit)}>
        {UNITS[unit]}
      </Dropdown.Item>
    ));
    return (
      <Dropdown className="col-12 p-0">
        <Dropdown.Toggle className="col-12 p-0 d-flex justify-content-between align-items-center px-3">
          <div className="d-flex flex-row">
            <p className="d-none d-md-flex m-0">{UNITS[item.weight_unit]}</p>
            <p className="d-flex d-md-none m-0">{item.weight_unit}</p>
          </div>
        </Dropdown.Toggle>
        <Dropdown.Menu>{list}</Dropdown.Menu>
      </Dropdown>
    );
  };

  const renderCurrency = () => {
    const list = Object.keys(CURRENCY).map((currency, idx) => (
      <Dropdown.Item
        key={idx}
        onClick={() => onUpdate("value_currency", currency)}
      >
        {CURRENCY[currency].description}
      </Dropdown.Item>
    ));
    return (
      <Dropdown className="col-12 p-0">
        <Dropdown.Toggle className="col-12 p-0 d-flex justify-content-between align-items-center px-3">
          {CURRENCY[item.value_currency].description}
        </Dropdown.Toggle>
        <Dropdown.Menu>{list}</Dropdown.Menu>
      </Dropdown>
    );
  };

  return (
    <>
      <label className="d-flex flex-column">
        Description
        <input
          value={item.description}
          onChange={(e) => onUpdate("description", e.target.value)}
        />
        <p className={`text-danger ${errors.descriptionError ? "error" : ""}`}>
          Field is required
        </p>
      </label>
      <div className="quantity d-flex flex-row justify-content-between">
        <label className="d-flex flex-column p-0">
          Quantity
          <input
            type="number"
            onWheel={(e) => e.target.blur()}
            onScroll={(e) => e.target.blur()}
            min={0}
            value={item.quantity}
            onChange={(e) => onUpdate("quantity", e.target.value)}
          />
          <p className={`text-danger ${errors.quantityError ? "error" : ""}`}>
            Field is required
          </p>
          <p
            className={`text-danger ${errors.quantityTypeError ? "error" : ""}`}
          >
            Field must be number
          </p>
        </label>
        <label className="d-flex flex-column p-0">
          Net Weight
          <input
            type="number"
            onWheel={(e) => e.target.blur()}
            onScroll={(e) => e.target.blur()}
            min={0}
            value={item.net_weight}
            onChange={(e) => onUpdate("net_weight", e.target.value)}
          />
          <p className={`text-danger ${errors.net_weightError ? "error" : ""}`}>
            Field is required
          </p>
          <p
            className={`text-danger ${errors.net_weightTypeError ? "error" : ""}`}
          >
            Field must be number
          </p>
          <p
            className={`text-danger ${errors.net_weightValueError ? "error" : ""}`}
          >
            Net weight cannot be greater than parcel weight
          </p>
          <p>
            <span>Quantity * Weight per item</span>
          </p>
        </label>
        <label className="d-flex flex-column p-0">&nbsp;{renderWeight()}</label>
      </div>
      <div className="value col-12 p-0 d-flex flex-row justify-content-between">
        {!hideValueCurrency && (
          <label className="d-flex flex-column">
            Value Currency{renderCurrency()}
            <p
              className={`text-danger ${errors.value_currencyError ? "error" : ""}`}
            >
              Field is required
            </p>
          </label>
        )}
        <label
          className="d-flex flex-column"
          style={{ flexGrow: hideValueCurrency ? 1 : undefined }}
        >
          Value Amount
          {hideValueCurrency ? (
            <div className="d-flex flex-row align-items-center input-prefix-group">
              <span className="input-prefix">KES</span>
              <input
                type="number"
                onWheel={(e) => e.target.blur()}
                onScroll={(e) => e.target.blur()}
                min={0}
                value={item.value_amount}
                onChange={(e) => onUpdate("value_amount", e.target.value)}
              />
            </div>
          ) : (
            <input
              type="number"
              onWheel={(e) => e.target.blur()}
              onScroll={(e) => e.target.blur()}
              min={0}
              value={item.value_amount}
              onChange={(e) => onUpdate("value_amount", e.target.value)}
            />
          )}
          <p
            className={`text-danger ${errors.value_amountError ? "error" : ""}`}
          >
            Field is required
          </p>
          <p
            className={`text-danger ${errors.value_amountTypeError ? "error" : ""}`}
          >
            Field must be number
          </p>
        </label>
      </div>
    </>
  );
};

export default ItemDetailsFormFields;
